module.exports = {
  fieldsNeeded: ['device'],
  match: function(visitorProfile, cond) {
    return visitorProfile.device === cond.value;
  },
};
